module.exports = __webpack_public_path__ + "static/media/next.70c0e909.svg";